import { render, staticRenderFns } from "./TiersStocksNormes.vue?vue&type=template&id=401c0e6a&"
import script from "./TiersStocksNormes.vue?vue&type=script&lang=js&"
export * from "./TiersStocksNormes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports